// extracted by mini-css-extract-plugin
export default {"login-form":"Login_login-form__079DZ","form-type":"Login_form-type__im4-g","Errors":"Login_Errors__t5+d-"};